const default_state = {
    error: null,
    upload: null,
};
export const upload_attachments_reducer = (state = default_state, action) => {
    switch (action.type) {
        case 'IS_LOADING_UPLOAD_MAINTENANCE_ATTACHMENT':
            return {
                ...state,
                upload: {
                    ...state.upload,
                    is_loading: action.is_loading,
                },
            };
        case 'SET_MAINTENANCE_ATTACHMENT_IDS':
            return {
                ...state,
                upload: {
                    ...state.upload,
                    ids: action.ids,
                    filenames: action.filenames,
                },
            };
        case 'RESET_UPLOAD_MAINTENANCE_ATTACHMENT':
            return {
                ...state,
                upload: {
                    ...state.upload,
                    ids: undefined,
                    filenames: undefined,
                },
            };
        case 'MAINTENANCE_ATTACHMENT_SET_MESSAGE':
            return { ...state, error: action.content };
        default:
            return state;
    }
};
